<div class="error-layout">
    <div class="error-layout__content">
        <img src="https://tweb-dev.s3-us-west-2.amazonaws.com/static/images/tweb-logo-color.png" alt="The World Egg Bank" />
        <h2 class="margin-top__l margin-bottom__l">Page not found</h2>
        <a class="button button--primary" href="https://theworldeggandspermbank.com" class="btn">Back to Website</a>
    </div>
</div>
